import "./IconMessage.scss";

export const IconMessage = () => {
  return <span className="icon-message"></span>;
};
